import { Modal as ModalAntd } from 'antd';
import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

const Modal = styled(ModalAntd)`
  min-width: 1000px;
  box-sizing: border-box;
  .ant-modal-content {
    background-color: ${COLOR.ALABASTER};
  }
  .ant-modal-body {
    padding: 30px 90px;
  }
  .ant-modal-footer {
    padding: 40px 90px;
    border: none;
  }
`;

export default Modal;
